// extracted by mini-css-extract-plugin
module.exports = {"state":"CourseState_state__1SSVZ","draft":"CourseState_draft__1qfyJ","published":"CourseState_published__3ywWh"};